import React from 'react';
import { CSSProperties } from 'react';
import RouteWrapper from '../route_wrapper';
import useTheme from '../../utilities/hooks/theme';
import View from '../view';
import { isSmartPhone } from '../../utilities/helper';

interface ScreenBackgroundWrapperProps {
  children?: object;
  className?: string | undefined;
  style?: CSSProperties | undefined;
}

const ScreenBackgroundWrapper = ({ children, className, style }: ScreenBackgroundWrapperProps) => {
  return (
    <View
      style={{
        flex: 1,
        position: 'relative',
        height: '100%',
        ...style
      }}
      className={className}>
      {children}
    </View>
  );
};
interface Props {
  children?: object;
  className?: string | undefined;
  style?: CSSProperties | undefined;
  isHome?: boolean;
  isRouterWrap?: boolean;
  isCreateTeam?: boolean;
}

const ScreenBackground = ({
  children,
  className,
  style,
  isHome = false,
  isRouterWrap = false,
  isCreateTeam = false
}: Props) => {
  const { DashboardTheme: theme } = useTheme();
  const customStyle: CSSProperties = isHome
    ? {
        backgroundColor: isSmartPhone ? '#f2f2eb' : theme.dashboardBG
      }
    : isCreateTeam
    ? {
        backgroundColor: isSmartPhone ? '#24272F' : theme.createTeamBG
      }
    : {
        backgroundImage: `linear-gradient(${theme.dashboardBGStartGradient},${theme.dashboardBGCenterGradient},
  ${theme.dashboardBGEndGradient}
  )`
      };

  return (
    <>
      {isRouterWrap ? (
        <RouteWrapper>
          <ScreenBackgroundWrapper className={className} style={{ ...style, ...customStyle }}>
            {children}
          </ScreenBackgroundWrapper>
        </RouteWrapper>
      ) : (
        <ScreenBackgroundWrapper className={className} style={{ ...style, ...customStyle }}>
          {children}
        </ScreenBackgroundWrapper>
      )}
    </>
  );
};
ScreenBackground.defaultProps = {
  isHome: false,
  isRouterWrap: false
};
export default React.memo(ScreenBackground);
